import i18next from 'i18next'

import {
  ChildReferralListPath,
  CrmAccountsListPath,
  LeadListPath,
  ParentReferralListPath,
} from 'utils/genericData/pathList'

type MenuItemObject = {
  id: string
  label: string
  path: string
  active: boolean
  items?: MenuItemObject[]
  backendId: number
}
export const sidebarMenus: MenuItemObject[] = [
  {
    id: 'leads',
    label: i18next.t('navigation.sidebarMenu.leads') ?? 'Leads',
    path: LeadListPath,
    active: true,
    backendId: 20,
  },
  {
    id: 'parentReferral',
    label: i18next.t('navigation.sidebarMenu.parentReferrals') ?? 'Patient Referrals',
    path: ParentReferralListPath,
    active: true,
    backendId: 16,
  },
  {
    id: 'childReferral',
    label: i18next.t('navigation.sidebarMenu.childReferrals') ?? 'Community Referrals',
    path: ChildReferralListPath,
    active: true,
    backendId: 17,
  },
  {
    id: 'discussions',
    label: i18next.t('navigation.sidebarMenu.discussions') ?? 'Discussions',
    path: '/discussions',
    active: true,
    backendId: 7,
  },
  {
    id: 'taskManagement',
    label: i18next.t('navigation.sidebarMenu.taskManagement') ?? 'Task Management',
    path: '/taskManagement/tasks',
    active: true,
    backendId: 18,
  },
  {
    id: 'notifications',
    label: i18next.t('navigation.sidebarMenu.notifications') ?? 'Notifications',
    path: '/notifications/list',
    active: true,
    backendId: 12,
  },
  {
    id: 'dashboard',
    label: i18next.t('navigation.sidebarMenu.dashboard') ?? 'Dashboard',
    path: '/dashboard/view',
    active: true,
    backendId: 1,
  },
  {
    id: 'bedBoardManagement',
    label: i18next.t('navigation.sidebarMenu.bedBoardManagement') ?? 'Bedboard Management',
    path: '/bedBoardManagement/statistics',
    active: true,
    backendId: 19,
  },
  {
    id: 'drugprice',
    label: i18next.t('navigation.sidebarMenu.drugPrice') ?? 'Drug Price',
    path: '/drugprice/list',
    active: true,
    backendId: 8,
  },
  {
    id: 'organization',
    label: i18next.t('navigation.sidebarMenu.organization') ?? 'Organizations',
    path: '/organization/list',
    active: true,
    backendId: 2,
  },
  {
    id: 'myOrganization',
    label: i18next.t('navigation.sidebarMenu.myOrganization') ?? 'My Organization',
    path: '/organization/view',
    active: true,
    backendId: 13,
  },
  {
    id: 'facility',
    label: i18next.t('navigation.sidebarMenu.facility') ?? 'Communities',
    path: '/facility/list',
    active: true,
    backendId: 3,
  },
  {
    id: 'myFacility',
    label: i18next.t('navigation.sidebarMenu.myFacility') ?? 'My Community',
    path: '/myFacility',
    active: true,
    backendId: 14,
  },
  {
    id: 'crmAccounts',
    label: i18next.t('navigation.sidebarMenu.crmAccounts') ?? 'CRM Accounts',
    path: CrmAccountsListPath,
    active: true,
    backendId: 21,
  },
  {
    id: 'userManagement',
    label: i18next.t('navigation.sidebarMenu.userManagement') ?? 'User Management',
    path: '/userManagement/list',
    active: true,
    backendId: 9,
  },
  {
    id: 'roles',
    label: i18next.t('navigation.sidebarMenu.rolesAndPermissions') ?? 'Roles & Permissions',
    path: '/roles/list',
    active: true,
    backendId: 10,
  },
  // {
  //   id: 'privacyPolicy',
  //   label: i18next.t('navigation.sidebarMenu.privacyPolicy'),
  //   path: 'privacyPolicy',
  //   active: true,
  //   backendId: 15,
  // },
  {
    id: 'calculationconfiguration',
    label: i18next.t('navigation.sidebarMenu.calculationConfig') ?? 'Calculation Config',
    path: '/calculation-configuration',
    active: false,
    backendId: 5,
  },
  {
    id: 'supportTicket',
    label: i18next.t('navigation.sidebarMenu.supportTicket') ?? 'Support Ticket',
    path: '/support-ticket',
    active: false,
    backendId: 6,
  },
  {
    id: 'SubscriptionAudit',
    label: i18next.t('navigation.sidebarMenu.subscription') ?? 'Subscription/Audit',
    path: '/Subscription-Audit',
    active: false,
    backendId: 11,
  },
]
